import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import _Classnames from 'classnames';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

const useStyles = makeStyles(theme => ({
  root: {
    borderRight: '1px solid #EFEFEF',
  },
  item: {
    paddingLeft: 24,
  },
  itemWrapper: {
    height: 34,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    position: 'relative',
    '&:hover': {
      background: theme.palette.primary.main,
      color: '#fff',
    },
  },
  active: {
    background: theme.palette.primary.main,
    color: '#fff',
    '&:after': {
      left: '100%',
      top: '50%',
      border: 'solid transparent',
      content: '" "',
      height: 0,
      width: 0,
      position: 'absolute',
      pointerEvents: 'none',
      borderColor: 'rgba(7, 87, 139, 0)',
      borderLeftColor: '#07578B',
      borderWidth: 6,
      marginTop: '-6px',
    },
  },
}));

function CategoriesList({ themes, onClick, selected, clientDetails }) {
  const classes = useStyles();
  const clientSlug =
    _get(clientDetails, 'client.slug') || _get(clientDetails, 'slug');
  return (
    <Grid item xs={4} className={classes.root}>
      <Grid container>
        {themes.map(({ title, clientCollection }, index) => {
          const hasClient = !_isEmpty(_get(clientCollection, 'items'));
          const isFind =
            hasClient &&
            clientCollection.items.find(({ slug }) => slug === clientSlug);
          if (hasClient && !isFind) return null;
          return (
            <Grid
              item
              xs={12}
              className={_Classnames(
                classes.itemWrapper,
                selected === index ? classes.active : undefined,
              )}
              onClick={() => onClick(index)}
              key={title}
            >
              <Typography variant="caption" className={classes.item}>
                {title}
              </Typography>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
}

CategoriesList.propTypes = {
  themes: PropTypes.array,
  onClick: PropTypes.func,
  selected: PropTypes.number,
  clientDetails: PropTypes.object,
};

export default CategoriesList;
